// extracted by mini-css-extract-plugin
module.exports = {"form":"LoginForm_form__JE73_","formElement":"LoginForm_formElement__D2HJk","formElementLink":"LoginForm_formElementLink__J91v9"};